import 'angular:locale/data:en-GB';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
